function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 19 12"
}, props), React.createElement("path", {
  d: "M18 4.9c.5.6.5 1.4 0 2-1.3 1.6-4.3 4.7-8.6 4.7S2.1 8.5.8 6.9c-.5-.6-.5-1.4 0-2C2.1 3.3 5.1.2 9.4.2s7.3 3.1 8.6 4.7zM9.4 9.7c2.2 0 4-1.7 4-3.8s-1.8-3.8-4-3.8-4 1.7-4 3.8 1.8 3.8 4 3.8zm0-5.7c1.1 0 2 .8 2 1.9s-.9 1.9-2 1.9-2-.8-2-1.9.9-1.9 2-1.9z"
})));